// extracted by mini-css-extract-plugin
export default {"buttonBox":"FeedbackOptions_buttonBox__3iwO0","button":"FeedbackOptions_button__V-Y8u"};